import ActionMenu, { Action } from "../../../../components/ui/materialui/actionMenu";
import { Tasa, TasaEditar } from "../models/tasa";
import EditIcon from "@mui/icons-material/Edit";
import { eliminarTasa } from "../service/serviceTasas";
import { GridDeleteIcon } from "@mui/x-data-grid";
import { StatusCode, TipoFuncionalidad } from "../../../../utils/enums";
import { add } from "date-fns";
import { useToast } from "../../../../hooks/useToast";
import { useState } from "react";
import ConfirmationModal from "../../../../components/ui/materialui/confirmationModal";
import { usePermissions } from "../../../../components/auth/ProtectedRoute";


interface IProps {
  tasa: Tasa;
  control: any;
  setTasasEditar: React.Dispatch<React.SetStateAction<TasaEditar | undefined>>;
  setModalDetalle: React.Dispatch<React.SetStateAction<boolean>>;
}

const AccionesTasas: React.FC<IProps> = ({ tasa, control, setTasasEditar, setModalDetalle }) => {
  const { addToast } = useToast();
  const { hasPermission } = usePermissions();
  const puedeEditar = hasPermission(TipoFuncionalidad.Maestros_editar);
  const [modalConfirmacion, setModalConfirmacion] = useState({
    show: false,
    title: '',
    message: '',
    metodo: () => {
    },
  });

  const handleEditarClick = async () => {
    setTasasEditar({
      ...tasa,
      tasa: tasa.valor,
      fechaInicioVigencia: tasa.fechaInicioVigencia,
      fechaTerminoVigencia: tasa.fechaTerminoVigencia,
      montoDesde: tasa.montoDesde,
      montoHasta: tasa.montoHasta,
    });

    setModalDetalle(true);
  };

  const handleDelete = async () => {
    const resp = await eliminarTasa(tasa.id);
    if (resp.status === StatusCode.NoContent) {
      await control.fetchData();
      addToast({
        mostrar: true,
        titulo: 'Confirmación',
        tipo: 'Success',
        mensaje:
          'Tasa eliminada con éxito.'
      });
    }
  }

  const handleEliminarClick = async () => {

    setModalConfirmacion({
      show: true,
      title: 'Eliminar seguro',
      message: `¿Estás seguro de eliminar la tasa seleccionada?`,
      metodo: () => {
        handleDelete()
      },
    });


  }
  const actions: Action[] = [];
  if (puedeEditar) {
    actions.push({
      label: "Editar",
      icon: <EditIcon fontSize="small" />,
      onClick: () => handleEditarClick()
    });
  }
  actions.push({
    label: "Eliminar",
    icon: <GridDeleteIcon fontSize="small" />,
    onClick: async () => handleEliminarClick()
  });


  return (
    <>
      <ConfirmationModal
        onHide={() =>
          setModalConfirmacion({
            ...modalConfirmacion,
            show: false,
          })
        }
        onConfirm={modalConfirmacion.metodo}
        show={modalConfirmacion.show}
        title={modalConfirmacion.title}
        message={modalConfirmacion.message}
      />
      <ActionMenu actions={actions} />
    </>
  );
};

export default AccionesTasas;
